import $ from 'jquery';
import 'launch/lib/legacy-uploader';

export default function () {
    this.attributes({
        counter: 0,
        button: false,
        singleFileOnly: false,
        extraDropzones: [document.body],
        listselector: '.js-uploader-list',
    });

    this.list = function () {
        return this.$node.find(this.$node.data('uploader-list-selector'));
    };

    this.prototype = function () {
        return this.$node.data('prototype').replace(/__name__/g, this.attr.counter);
    };

    this.injectHiddenFieldOnSubmitted = function (data) {
        var $field = $(this.prototype());

        $(data.element).append($field);

        for (var index in this.fields()) {
            var field = this.fields()[index];
            $(data.element, $field)
                .find('[name*="[' + field + ']"]')
                .val(data.response[field]);
        }

        this.attr.counter++;
    };

    this.onComplete = function (ev, data) {
        if (data.response.success) {
            if (this.attr.singleFileOnly && this.list().children().length > 1) {
                this.list().children(':first').remove();
            }

            this.injectHiddenFieldOnSubmitted(data);
            this.trigger('uploaderFileUploader');
        } else {
            $(data.element).find('input').remove();
        }

        this.trigger('formChanged');
    };

    this.onDeleteComplete = function (ev, data) {
        this.trigger('uploaderFileDeleted', $(data.element).data('id'));
        this.trigger('formChanged');
    };

    this.event = function (name) {
        return 'uploader:' + name + ':' + this.uploader().getName();
    };

    this.fields = function () {
        return this.$node.data('fields');
    };

    this.uploader = function () {
        return this.attr.uploader;
    };

    this.onRemove = function () {
        this.teardown();
    };

    this.after('initialize', function () {
        this.attr.counter = this.list().children().length;

        this.attr.uploader = this.$node
            .uploader({
                button: this.attr.button,
                multiple: !this.attr.singleFileOnly,
                extraDropzones: this.attr.extraDropzones,
                listselector: this.attr.listselector,
            })
            .data('uploader');

        this.on('remove', this.onRemove);
        this.on(document, this.event('complete'), this.onComplete);
        this.on(document, this.event('deleteComplete'), this.onDeleteComplete);
    });
}



// WEBPACK FOOTER //
// ./src/web/js/app/modules/mixins/with-uploader.js